// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_PITCHES, setWebskedPitches } from '../websked'

export default (action$, store, { serviceResolver }) =>
  action$.ofType(ACTION_WEBSKED_PITCHES).mergeMap((action) => {
    const webskedService = serviceResolver('webskedService')
    return Observable.from(webskedService.getWebskedStory())
      .map((results) => {
        return setWebskedPitches(results)
        // webskedService swallows http request error so unlikely this will occur
      })
      .catch((error) => Observable.of(errorAction(error)))
  })
